import {
  FLOATING_TOOL_INSPECTION_MOVED,
  FLOATING_TOOL_INSPECTION_OPEN,
  FLOATING_TOOL_INSPECTION_CLOSE,
  IS_DIRTY, CLOSE_MANIFOLD_ENTRY
} from "../lib/types";

export const floatingToolInspectionMoved = ( x, y ) => dispatch => {
  dispatch({
    type: FLOATING_TOOL_INSPECTION_MOVED,
    payload: { x, y }
  });
};

export const floatingToolInspectionOpen = ( row, col, accessory ) => dispatch => {
  dispatch({
    type: FLOATING_TOOL_INSPECTION_OPEN,
    payload: {
      row,
      col,
      accessory
    }
  });
  dispatch({
    type: CLOSE_MANIFOLD_ENTRY
  });
  dispatch({
    type: IS_DIRTY,
    payload: true
  });

};

export const floatingToolInspectionClose = () => dispatch => {
  dispatch({
    type: FLOATING_TOOL_INSPECTION_CLOSE
  });
};



// WEBPACK FOOTER //
// ./src/actions/floating-tool-inspection-port-actions.js